import SelectBench from "./SelectBench";
import { Link } from "react-router-dom";

const LogoSection = ({ benchName, benchCode }) => {
  const benchUrl =
    benchName === "PRINCIPAL" ? "/" : `/${benchCode?.toLowerCase()}`;
  return (
    <>
      <div className="logo-sec-wrapper">
        <div className="container-fluid">
          <div className="row white-header">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 logo-sec">
              <Link className="logo-align " to={benchUrl}>
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}/images/logo.png`}
                  alt="emblem"
                  className="wow zoomIn"
                />
                <div className="brand-text">
                  <h4>
                    <span>RAILWAY CLAIMS TRIBUNAL</span>
                    <span className="logo-subtxt">
                      Online Court Services of RCT
                      <span className="logo-bench-span">{benchName} BENCH</span>
                    </span>
                  </h4>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 logo-wrapper-ryt">
              <div className="logo-ryt-buttons">
                <a
                  href="https://rct.indianrail.gov.in/"
                  target="_blank"
                  className="quick-btns light-bg-btn"
                >
                  Old Website Link
                </a>

                <a
                  href="https://cis.erct.gov.in/#/display-board"
                  className="quick-btns light-bg-btn"
                  target="_blank"
                >
                  Display Board
                </a>
                <a
                  href="https://efiling.erct.gov.in/#/"
                  target="_blank"
                  className="quick-btns light-bg-btn"
                >
                  e-Filing
                </a>
                <a
                  href="./Short_guide.pdf"
                  target="_blank"
                  className="click_link"
                >
                  {/* <img src="./images/info.svg" alt="" /> */}
                  <i class="fa-solid fa-info"></i>
                  Short guide for e-Filing
                </a>
                <a
                  href="https://cis.erct.gov.in/#/"
                  target="_blank"
                  className="quick-btns light-bg-btn"
                >
                  CIS
                </a>
                <SelectBench />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LogoSection;
